export function installPresetManagerShell(host, instanceId) {
  const prefix = `fishy-preset-manager-${instanceId}`;
  const stacksCompactHistory =
    host.getAttribute?.("data-compact-layout") === "stacked-history";
  const hostClasses = [
    "inline-flex",
    "w-full",
    "min-w-0",
    "max-w-full",
    "shrink",
  ];
  if (!stacksCompactHistory) {
    hostClasses.push("sm:w-auto", "sm:shrink-0");
  }
  host.classList?.add?.(...hostClasses);

  const compactControlClass = stacksCompactHistory
    ? "grid w-full max-w-full grid-cols-[minmax(0,1fr)_auto] items-center gap-2 sm:gap-x-2 sm:gap-y-1"
    : "grid w-full max-w-full grid-cols-[minmax(0,1fr)_auto] items-center gap-2 sm:flex sm:w-[26rem]";
  const compactOpenClass = stacksCompactHistory
    ? "col-span-2 sm:col-span-1 sm:col-start-1 sm:row-start-1"
    : "col-span-2 sm:col-auto";
  const compactActionsClass = stacksCompactHistory
    ? "join col-start-1 row-start-2 shrink-0 justify-self-start sm:col-start-2 sm:row-start-1"
    : "join col-start-1 row-start-2 shrink-0 justify-self-start";
  const compactHistoryClass = stacksCompactHistory
    ? "join col-start-2 row-start-2 shrink-0 justify-self-end"
    : "join col-start-2 row-start-2 shrink-0 justify-self-end";

  host.innerHTML = `
    <div class="${compactControlClass}" data-role="compact-control">
      <button type="button" class="btn btn-sm ${compactOpenClass} h-10 min-w-0 justify-start gap-2 bg-base-100 px-3 sm:h-8 sm:flex-1" data-action="open" data-role="open" aria-haspopup="dialog" aria-label="Open preset manager" data-fishy-tooltip="Open preset manager">
        <span class="grid size-4 shrink-0 place-items-center" data-role="compact-status-slot" aria-hidden="true">
          <span class="status status-sm status-neutral" data-role="compact-status-dot"></span>
        </span>
        <span class="min-w-0 flex-1 truncate text-left text-sm font-medium" data-role="compact-current-name">Preset</span>
        <svg class="fishy-icon size-5 shrink-0" viewBox="0 0 24 24" aria-hidden="true"><use width="100%" height="100%" href="#fishy-layout-fill"></use></svg>
      </button>
      <span class="sr-only" data-role="compact-current-status" role="status" aria-live="polite" aria-atomic="true">Unavailable</span>
      <div class="${compactActionsClass}" data-role="compact-actions">
        <button type="button" class="btn btn-sm btn-primary join-item h-10 min-h-10 w-10 shrink-0 px-0 [border-width:1px] sm:h-8 sm:min-h-8 sm:w-auto sm:px-3" data-action="save-current" data-role="compact-save" aria-label="Save">
          <svg class="fishy-icon size-4" viewBox="0 0 24 24" aria-hidden="true"><use width="100%" height="100%" href="#fishy-check-badge-solid"></use></svg>
          <span class="hidden sm:inline" data-role="button-label">Save</span>
        </button>
        <button type="button" class="btn btn-sm join-item h-10 min-h-10 w-10 shrink-0 px-0 [border-width:1px] [margin-inline-start:-1px] sm:h-8 sm:min-h-8 sm:w-auto sm:px-3" data-action="discard-current" data-role="compact-discard" aria-label="Discard">
          <svg class="fishy-icon size-4" viewBox="0 0 24 24" aria-hidden="true"><use width="100%" height="100%" href="#fishy-clear"></use></svg>
          <span class="hidden sm:inline" data-role="button-label">Discard</span>
        </button>
      </div>
      <div class="${compactHistoryClass}" data-role="compact-history">
        <button type="button" class="btn btn-sm btn-square join-item h-10 min-h-10 w-10 shrink-0 [border-width:1px] sm:h-8 sm:min-h-8 sm:w-8" data-action="undo" data-fishy-tooltip="Undo">
          <svg class="fishy-icon size-4" viewBox="0 0 24 24" aria-hidden="true"><use width="100%" height="100%" href="#fishy-back-2-fill"></use></svg>
          <span class="sr-only" data-role="button-label">Undo</span>
        </button>
        <button type="button" class="btn btn-sm btn-square join-item h-10 min-h-10 w-10 shrink-0 [border-width:1px] [margin-inline-start:-1px] sm:h-8 sm:min-h-8 sm:w-8" data-action="redo" data-fishy-tooltip="Redo">
          <svg class="fishy-icon size-4" viewBox="0 0 24 24" aria-hidden="true"><use width="100%" height="100%" href="#fishy-forward-2-fill"></use></svg>
          <span class="sr-only" data-role="button-label">Redo</span>
        </button>
      </div>
    </div>
    <input type="file" class="hidden" accept="application/json,.json" data-role="file-input" aria-label="Import presets">
    <dialog class="modal modal-bottom sm:modal-middle" data-role="dialog" aria-labelledby="${prefix}-title">
      <div class="modal-box flex h-[100dvh] max-h-[100dvh] w-full max-w-none flex-col overflow-hidden rounded-none p-0 sm:h-[min(44rem,calc(100dvh-2rem))] sm:max-h-[calc(100dvh-2rem)] sm:w-[calc(100%-2rem)] sm:max-w-7xl sm:rounded-box">
        <header class="navbar min-h-0 shrink-0 border-b border-base-300 bg-base-100 px-4 py-3 sm:px-6 sm:py-4">
          <div class="navbar-start min-w-0 flex-1 gap-2">
            <svg class="fishy-icon size-5 shrink-0" viewBox="0 0 24 24" aria-hidden="true"><use width="100%" height="100%" href="#fishy-layout-fill"></use></svg>
            <h2 id="${prefix}-title" class="truncate text-lg font-semibold tracking-tight sm:text-xl" data-role="manager-title">Preset Manager</h2>
          </div>
          <form method="dialog" class="navbar-end w-auto">
            <button type="submit" class="btn btn-circle btn-ghost min-h-10 min-w-10 sm:btn-sm sm:min-h-8 sm:min-w-8" aria-label="Close preset manager" data-role="close-manager">
              <svg class="fishy-icon size-4" viewBox="0 0 24 24" aria-hidden="true"><use width="100%" height="100%" href="#fishy-clear"></use></svg>
            </button>
          </form>
        </header>

        <div class="mx-4 mt-3 alert alert-soft alert-error sm:mx-6" role="alert" data-role="error-alert" hidden>
            <svg class="fishy-icon size-5 shrink-0" viewBox="0 0 24 24" aria-hidden="true"><use width="100%" height="100%" href="#fishy-warning"></use></svg>
            <span data-role="error-message"></span>
        </div>

        <div role="tablist" class="tabs tabs-box mx-3 my-2 grid shrink-0 grid-cols-2 sm:tabs-sm lg:hidden" aria-label="Preset workspace" data-role="workspace-tabs">
          <button type="button" role="tab" class="tab min-h-10 sm:min-h-8" data-action="workspace-tab" data-view="library" data-role="library-workspace-tab" aria-controls="${prefix}-library-panel">Presets</button>
          <button type="button" role="tab" class="tab min-h-10 sm:min-h-8" data-action="workspace-tab" data-view="details" data-role="details-workspace-tab" aria-controls="${prefix}-details-panel">Preset details</button>
        </div>

        <div class="grid min-h-0 flex-1 lg:grid-cols-[22rem_minmax(0,1fr)]">
            <aside id="${prefix}-library-panel" class="flex min-h-0 flex-col bg-base-200/35 lg:border-r lg:border-base-300" aria-labelledby="${prefix}-library-title" data-role="library-panel">
              <div class="flex items-center justify-between gap-3 px-4 pt-4 sm:px-5 sm:pt-5 lg:px-6 lg:pt-6">
                <div class="min-w-0">
                  <h3 id="${prefix}-library-title" class="text-base font-semibold tracking-tight" data-role="library-title">Presets</h3>
                  <p class="text-xs text-base-content/55" data-role="preset-count">0 saved</p>
                </div>
                <button type="button" class="btn btn-sm min-h-10 sm:min-h-8" data-action="import">
                  <svg class="fishy-icon size-4" viewBox="0 0 24 24" aria-hidden="true"><use width="100%" height="100%" href="#fishy-import"></use></svg>
                  <span data-role="import-label">Import</span>
                </button>
              </div>
              <label class="input mx-4 mt-4 min-h-10 w-auto shrink-0 sm:input-sm sm:mx-5 sm:min-h-8 lg:mx-6" for="${prefix}-search">
                <svg class="fishy-icon size-4 opacity-60" viewBox="0 0 24 24" aria-hidden="true"><use width="100%" height="100%" href="#fishy-search-field"></use></svg>
                <span class="sr-only" data-role="library-filter-label">Search presets</span>
                <input id="${prefix}-search" type="search" class="grow" autocomplete="off" placeholder="Search presets…" data-role="preset-search">
              </label>
              <div class="grid gap-2 px-4 py-4 sm:px-5 lg:px-6" data-role="preset-loading" role="status" hidden>
                <span class="sr-only" data-role="preset-loading-label">Loading preset workspace…</span>
                <div class="skeleton h-9 w-full"></div>
                <div class="skeleton h-9 w-full"></div>
                <div class="skeleton h-9 w-full"></div>
              </div>
              <template data-role="active-preset-icon-template">
                <svg class="fishy-icon size-5 text-current" viewBox="0 0 24 24" aria-hidden="true"><use width="100%" height="100%" href="#fishy-check-badge-solid"></use></svg>
              </template>
              <ul class="list min-h-0 flex-1 overflow-y-auto px-2 py-3 sm:px-3 lg:px-4" data-role="preset-list"></ul>
              <p class="px-4 py-8 text-center text-sm text-base-content/55" data-role="preset-empty" hidden>No presets match this search.</p>
            </aside>

            <section id="${prefix}-details-panel" class="flex min-h-0 min-w-0 flex-col bg-base-100 max-lg:hidden max-lg:overflow-y-auto" aria-labelledby="${prefix}-selected-title" data-role="details-panel">
              <div class="grid shrink-0 gap-4 border-b border-base-300 px-4 py-5 sm:px-6 lg:py-6">
                <div class="flex min-w-0 items-center justify-between gap-3">
                  <h3 id="${prefix}-selected-title" class="truncate text-lg font-semibold tracking-tight" data-role="selected-heading">Selected preset</h3>
                  <span class="flex shrink-0 items-center gap-2 text-sm font-semibold text-success" data-role="selected-active" hidden>
                    <svg class="fishy-icon size-4 text-current" viewBox="0 0 24 24" aria-hidden="true"><use width="100%" height="100%" href="#fishy-check-badge-solid"></use></svg>
                    <span class="translate-y-px" data-role="selected-active-label">Active</span>
                  </span>
                </div>

                <fieldset class="fieldset p-0">
                  <label class="label" for="${prefix}-selected-name" data-role="selected-name-label">Preset name</label>
                  <div class="grid gap-2 sm:grid-cols-[minmax(0,1fr)_auto]">
                    <input id="${prefix}-selected-name" class="input validator min-h-10 min-w-0 w-full sm:input-sm sm:min-h-8" type="text" maxlength="120" pattern=".*\\S.*" required autocomplete="off" data-role="selected-name" aria-describedby="${prefix}-selected-name-hint ${prefix}-selected-name-validation">
                    <button type="button" class="btn btn-primary min-h-10 w-full sm:btn-sm sm:min-h-8 sm:w-auto" data-action="use-selected">
                      <svg class="fishy-icon size-4" viewBox="0 0 24 24" aria-hidden="true"><use width="100%" height="100%" href="#fishy-check-badge-solid"></use></svg>
                      <span data-role="button-label">Activate preset</span>
                    </button>
                  </div>
                  <p id="${prefix}-selected-name-validation" class="validator-hint" data-role="selected-name-validation">Enter a preset name.</p>
                  <p id="${prefix}-selected-name-hint" class="sr-only" data-role="selected-name-hint"></p>
                </fieldset>

                <div class="grid grid-cols-2 gap-2 border-t border-base-300 pt-4 sm:flex sm:flex-wrap sm:items-center" data-role="selected-actions">
                  <div class="join col-span-2 w-full sm:w-auto" data-role="current-work-actions">
                    <button type="button" class="btn join-item min-h-10 flex-1 sm:btn-sm sm:min-h-8" data-action="save-current-dialog">
                      <svg class="fishy-icon size-4" viewBox="0 0 24 24" aria-hidden="true"><use width="100%" height="100%" href="#fishy-check-badge-solid"></use></svg>
                      <span data-role="button-label">Save</span>
                    </button>
                    <button type="button" class="btn join-item min-h-10 flex-1 sm:btn-sm sm:min-h-8" data-action="discard-current-dialog">
                      <svg class="fishy-icon size-4" viewBox="0 0 24 24" aria-hidden="true"><use width="100%" height="100%" href="#fishy-clear"></use></svg>
                      <span data-role="button-label">Discard</span>
                    </button>
                  </div>
                  <div class="join justify-self-start" data-role="current-history-actions">
                    <button type="button" class="btn btn-square join-item min-h-10 sm:btn-sm sm:min-h-8" data-fishy-tooltip="Undo" data-action="undo-dialog">
                      <svg class="fishy-icon size-4" viewBox="0 0 24 24" aria-hidden="true"><use width="100%" height="100%" href="#fishy-back-2-fill"></use></svg>
                      <span class="sr-only" data-role="button-label">Undo</span>
                    </button>
                    <button type="button" class="btn btn-square join-item min-h-10 sm:btn-sm sm:min-h-8" data-fishy-tooltip="Redo" data-action="redo-dialog">
                      <svg class="fishy-icon size-4" viewBox="0 0 24 24" aria-hidden="true"><use width="100%" height="100%" href="#fishy-forward-2-fill"></use></svg>
                      <span class="sr-only" data-role="button-label">Redo</span>
                    </button>
                  </div>
                  <button type="button" class="btn btn-outline min-h-10 whitespace-nowrap sm:btn-sm sm:min-h-8" data-action="save-local-to-account" hidden>
                    <svg class="fishy-icon size-4" viewBox="0 0 24 24" aria-hidden="true"><use width="100%" height="100%" href="#fishy-check-badge-solid"></use></svg>
                    <span data-role="button-label">Save to account</span>
                  </button>
                  <button type="button" class="btn btn-outline min-h-10 sm:btn-sm sm:min-h-8" data-action="clone-selected">
                    <svg class="fishy-icon size-4" viewBox="0 0 24 24" aria-hidden="true"><use width="100%" height="100%" href="#fishy-copy"></use></svg>
                    <span data-role="button-label">Clone</span>
                  </button>
                  <button type="button" class="btn btn-outline min-h-10 sm:btn-sm sm:min-h-8" data-action="export-selected">
                    <svg class="fishy-icon size-4" viewBox="0 0 24 24" aria-hidden="true"><use width="100%" height="100%" href="#fishy-export"></use></svg>
                    <span data-role="button-label">Export</span>
                  </button>
                  <button type="button" class="btn btn-error btn-outline min-h-10 sm:btn-sm sm:min-h-8" data-action="delete-selected">
                    <svg class="fishy-icon size-4" viewBox="0 0 24 24" aria-hidden="true"><use width="100%" height="100%" href="#fishy-trash"></use></svg>
                    <span data-role="button-label">Delete</span>
                  </button>
                </div>

                <form class="fieldset rounded-box border border-base-300 bg-base-200/40 p-3 sm:p-4" data-role="save-as-form" hidden>
                  <label class="label" for="${prefix}-save-as-name" data-role="save-as-name-label">New preset name</label>
                  <div class="flex flex-col gap-2 sm:flex-row">
                    <input id="${prefix}-save-as-name" class="input input-sm min-w-0 flex-1" type="text" maxlength="120" autocomplete="off" data-role="save-as-name">
                    <div class="flex gap-2">
                      <button type="submit" class="btn btn-neutral min-h-10 sm:btn-sm sm:min-h-8" data-action="save-as" data-role="save-as-submit">Save</button>
                      <button type="button" class="btn btn-ghost min-h-10 sm:btn-sm sm:min-h-8" data-action="cancel-save-as" data-role="save-as-cancel">Cancel</button>
                    </div>
                  </div>
                </form>
              </div>

              <div role="tablist" class="tabs tabs-border shrink-0 px-4 pt-2 sm:tabs-sm sm:px-6" aria-label="Preset details" data-role="detail-tabs">
                <button type="button" role="tab" class="tab min-h-10 sm:min-h-8" data-action="detail-tab" data-view="changes" data-role="changes-tab">Unsaved changes</button>
                <button type="button" role="tab" class="tab min-h-10 sm:min-h-8" data-action="detail-tab" data-view="history" data-role="history-tab">History</button>
              </div>

              <section class="min-h-0 flex-1 p-4 pt-3 sm:px-6 sm:pt-4 lg:overflow-y-auto" role="tabpanel" data-role="changes-panel">
                <p class="mb-3 text-sm text-base-content/65" data-role="changes-summary"></p>
                <div class="grid gap-3 sm:hidden" data-role="changes-cards"></div>
                <div class="hidden max-w-full overflow-x-auto rounded-box border border-base-300 sm:block" data-role="changes-table-wrap">
                  <table class="table table-sm">
                    <thead>
                      <tr>
                        <th data-role="changes-setting-heading">Setting</th>
                        <th data-role="changes-old-heading">Old</th>
                        <th data-role="changes-new-heading">New</th>
                      </tr>
                    </thead>
                    <tbody data-role="changes-list"></tbody>
                  </table>
                </div>
                <p class="py-8 text-center text-sm text-base-content/55" data-role="changes-empty" hidden>No differences from this preset.</p>
              </section>

              <section class="min-h-0 flex-1 overflow-auto overscroll-x-contain p-4 pt-3 sm:px-6 sm:pt-4" role="tabpanel" data-role="history-panel" hidden>
                <label class="label mb-2 ml-auto w-fit cursor-pointer gap-2 text-xs text-base-content/65" data-role="history-alternates-control" hidden>
                  <span data-role="history-alternates-label">Show alternate branches</span>
                  <input type="checkbox" class="checkbox checkbox-sm" data-role="history-alternates-toggle" aria-controls="${prefix}-history-list">
                </label>
                <ol id="${prefix}-history-list" class="grid min-w-full" data-role="history-list"></ol>
                <p class="py-8 text-center text-sm text-base-content/55" data-role="history-empty" hidden>No recorded changes for this preset.</p>
              </section>
            </section>
        </div>
      </div>
      <form method="dialog" class="modal-backdrop"><button type="submit">close</button></form>
    </dialog>
  `;
}

export function localizePresetManagerShell(host, translate) {
  if (typeof translate !== "function") {
    return;
  }
  const text = (role, key, fallback) => {
    const element = host?.querySelector?.(`[data-role="${role}"]`);
    if (element) {
      element.textContent = translate(key, fallback);
    }
  };
  const attribute = (role, name, key, fallback) => {
    host?.querySelector?.(`[data-role="${role}"]`)?.setAttribute?.(
      name,
      translate(key, fallback),
    );
  };

  attribute("open", "aria-label", "presets.manager.open", "Open preset manager");
  attribute("close-manager", "aria-label", "presets.manager.close", "Close preset manager");
  attribute("file-input", "aria-label", "presets.action.import_file", "Import presets");
  text("selected-active-label", "common.status.active", "Active");
  text("preset-loading-label", "presets.state.loading", "Loading preset workspace…");
  text("selected-name-validation", "presets.name.required", "Enter a preset name.");
  text("save-as-name-label", "presets.save_as.name_label", "New preset name");
  text("save-as-submit", "common.action.save", "Save");
  text("save-as-cancel", "common.action.cancel", "Cancel");
  attribute("detail-tabs", "aria-label", "presets.details.label", "Preset details");
  text("changes-tab", "presets.tab.changes", "Unsaved changes");
  text("history-tab", "presets.tab.history", "History");
  text("history-alternates-label", "presets.history.show_alternates", "Show alternate branches");
  text("library-title", "presets.tab.presets", "Presets");
  text("library-workspace-tab", "presets.tab.presets", "Presets");
  text("details-workspace-tab", "presets.details.label", "Preset details");
  attribute("workspace-tabs", "aria-label", "presets.manager.description", "Preset workspace");
  text("import-label", "common.action.import", "Import");
  text("library-filter-label", "presets.library.search", "Search presets");
  attribute("preset-search", "placeholder", "presets.quick_switch.search", "Search presets…");
  text("changes-setting-heading", "presets.changes.setting", "Setting");
  text("changes-old-heading", "presets.changes.old", "Old");
  text("changes-new-heading", "presets.changes.new", "New");
  text("changes-empty", "presets.changes.empty", "No differences from this preset.");
  text("history-empty", "presets.history.empty_selected", "No recorded changes for this preset.");
}

export function downloadPresetDocument(filename, value) {
  const blob = new Blob([JSON.stringify(value, null, 2)], {
    type: "application/json;charset=utf-8",
  });
  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.download = String(filename ?? "").trim() || "presets.json";
  link.hidden = true;
  document.body.append(link);
  link.click();
  link.remove();
  URL.revokeObjectURL(url);
}
